import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

// SPA router. queryClient is injected from main.tsx via router.update.
export const router = createRouter({
  routeTree,
  context: { queryClient: undefined as unknown as QueryClient },
  scrollRestoration: true,
  defaultPreloadStaleTime: 0,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
